<template>
    <div>
        <form style="width: 100%">
            <CRow>
                <CCol md="6">
                    <CCard>
                        <CCardHeader>
                            <strong>금액 청구</strong>
                        </CCardHeader>
                        <CCardBody>
                            <CForm>
                                <CInput
                                        label="이름"
                                        description="환자이름"
                                        placeholder="환자이름"
                                        horizontal
                                        v-model="custItem.name"
                                        Disabled
                                />
                                <CInput
                                        label="진료번호"
                                        placeholder="Text"
                                        description="환자진료번호"
                                        horizontal
                                        v-model="custItem.registNo"
                                        Disabled
                                />
                                <div role="group" class="form-group form-row">
                                    <label for="uid-rw1ppxoxk3h" class="col-form-label col-sm-3"> 미납액 </label>
                                    <div class="col-sm-9">
                                        <div class="input-group">
                                            <input class="form-control" id="uid-rw1ppxoxk3h" type="text" name="input3-group1"  disabled=""  v-model="custItem.charge" placeholder="0">
                                            <div class="input-group-append"><span class="input-group-text">원</span></div>
                                        </div>
                                        <small class="form-text text-muted w-100">미납액</small>
                                    </div>
                                </div>
                                <CInput
                                        label="청구항목"
                                        placeholder="청구항목을 입력해주세요"
                                        description="예) 6월 정기분"
                                        horizontal
                                        v-model="item"
                                />
                                <!--<CInput
                                        label="청구액"
                                        description="입력하신 금액만큼 미납액에서 차감됩니다."
                                        placeholder="0"
                                        horizontal
                                        v-model="amount"
                                />-->
                                <div role="group" class="form-group form-row">
                                    <label for="uid-rw1ppxoxk3h" class="col-form-label col-sm-3"> 청구액 </label>
                                    <div class="col-sm-9">
                                        <div class="input-group">
                                            <input class="form-control" id="uid-rw1ppxoxk3h" type="text" name="input3-group1" v-model="amount" placeholder="0" v-on:keyup="amountCount">
                                            <div class="input-group-append"><span class="input-group-text">원</span></div>
                                        </div>
                                        <small class="form-text text-muted w-100">예) 6월 정기분</small>
                                    </div>
                                </div>
                                <div role="group" class="form-group form-row">
                                    <label for="uid-rw1ppxoxk3h" class="col-form-label col-sm-3"> 납부할 총액 </label>
                                    <div class="col-sm-9">
                                        <div class="input-group">
                                            <input class="form-control" id="uid-rw1ppxoxk3h" type="text" name="input3-group1"  disabled=""  v-model="totalAmount" placeholder="0">
                                            <div class="input-group-append"><span class="input-group-text">원</span></div>
                                        </div>
                                        <small class="form-text text-muted w-100">납부할 총액</small>
                                    </div>
                                </div>
                                <CRow form class="form-group" :key="name">
                                    <CCol tag="label" sm="3" class="col-form-label">
                                        <div class="form-check form-check-inline mr-1">
                                            <input class="form-check-input" id="inline-checkbox1" type="checkbox" value="check1" v-model="msgChk">
                                            <label class="form-check-label" for="inline-checkbox1">알림메시지</label>
                                        </div>
                                    </CCol>
                                    <div class="col-md-9 col-form-label">
                                        <CTextarea v-model="msg"></CTextarea>
                                    </div>
                                </CRow>
                            </CForm>
                        </CCardBody>
                        <CCardFooter>
                            <CButton type="button" size="sm" color="primary"   @click="submit"><CIcon name="cil-check-circle"/> 청구하기</CButton>
                        </CCardFooter>
                    </CCard>
                </CCol>
            </CRow>
        </form>
    </div>
</template>
<style>
    .btn-col-margin{
        margin-top: 5px;
        margin-left: 15px;
        margin-right: 10px;
    }
    .col-title{
        width: 20%;
    }
    .table-span-margin{
        margin-left: 10%;
    }
</style>
<script>
    import CTableWrapper from "../base/PayManageInsertForm";
    import Table from "../base/Table";
    import axios from "axios";

    export default {
        name: 'PayManageInsertForm',
        components: {Table, CTableWrapper},
        data() {
            return{
                newItems: [],
                custItem:[],
                custName: '',
                resgistNo: '',
                item: '',
                amount: '',
                totalAmount: '',
                checkedMessage: '',
                body: '',
                title: '',
                name: '',
                //msg:'강남요양병원입니다. 이번달 결제일은 25일이며, {환자명} 님의 결제액은 {청구액} 원 입니다. 등록하신 앱에서 편리하게 분할로 결제하실수 있습니다.' ,
                msg:'안녕하십니까? 실버벨입니다. 이번달 청구금액이 있습니다. 등록하신 앱에서 금액확인 및 결제가 가능합니다. ' ,
                msgChk:true
            }
        }
        ,mounted() {
            const custId = this.$route.params.custId;

            axios.get('silver/cust/charge/'+custId)
                .then(res => {
                    this.custItem = res.data.cust;
                    this.totalAmount = res.data.cust.charge - this.amount;
                })
                .catch(function(error) {
                    console.log(error);
                });
        }
        ,methods: {
            submit () {
                axios.post('/silver/cust/insertCharge', {
                    custId: this.$route.params.custId,
                    custName: this.custItem.name,
                    registNo: this.custItem.registNo,
                    item: this.item,
                    amount: this.amount,
                    msg: this.msg,
                    msgChk: this.msgChk
                })
                    .then(data => {
                        alert("해당금액이 청구되었습니다.");
                        this.$router.push({name:"paymanageupdate", params: {custId: this.$route.params.custId}});

                    })
                    .catch(function (error) {
                        console.log(error)
                    });
            },
            comma(val){
                return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
            amountCount(val){
                console.log(val);
                this.totalAmount = Number(this.custItem.charge) +  Number(this.amount);
            }
        }
    }
</script>
